module.exports = __webpack_public_path__ + "img/whatsapp-logo.9c06c3b1.png";